import React from 'react'
import { MDBTable, MDBTableBody, MDBTableHead } from "mdb-react-ui-kit";
import {  useGetBusinessPlanQuery } from '../../redux/API/channelPartnerBusinessApi';
import { formatIndianNumber } from '../../Constant/utils';
import axios from 'axios';
import { cpbaseUrl } from '../../Constant/Matcher';
const BusinessPlanCard = ({setShowBusinessCard}) => {
const userData = JSON.parse(localStorage.getItem("userData"));
const cpId = userData?.validateEmail && userData?.validateEmail[0]?._id;

const {data} = useGetBusinessPlanQuery(cpId)  


const handleDelete = () => {
  axios.get(`${cpbaseUrl}recaculate-businessplan?cpid=${cpId}`)
  setShowBusinessCard(false)
}

  return (
    <>
     <div className="card p-3">
            <h5 className='mb-3'>Business Forcast</h5>
            <div>
            <MDBTable
              hover
              striped
              style={{ backgroundColor: "RGB(255 255 255)", fontSize: "14px" }}
              className='verticle-table'
            >
              <MDBTableHead
                style={{ backgroundColor: "#5A4344", color: "white" }}
              >
                <tr>
                  <th scope="col" >Year</th>
                  <th scope="col" >Year Opening Sale</th> 
                  <th scope="col" >Net Sale</th>
                  <th scope="col" >Year End Sale</th>
                  <th scope="col" >Total Revenue</th>
                </tr>
              </MDBTableHead>
              <MDBTableBody>
                {
                  data && data?.designBusiness[0]?.yearlyData?.map((item, index) => (
                      <tr key={index}>
                        <td>{item?.year}</td>
                        <td>{formatIndianNumber(item?.equityOpenings)}</td>
                        <td>{formatIndianNumber(item?.equityNetScale)}</td>
                        <td>{formatIndianNumber(item?.equityEndSales)}</td>
                        <td>{formatIndianNumber(item?.equityRevenue)}</td>
                      </tr>
                        ))
                      }
              </MDBTableBody>
            </MDBTable>
            <button onClick={handleDelete} className='float-end border-0' style={{
                        backgroundColor: "#9DC913",
                        padding: "5px 10px",
                        borderRadius: "4px",
                        color: "white",
                      }}>Recalculate</button>
                      </div>
     </div>
    </>
  )
}

export default BusinessPlanCard